<!-- Content Wrapper Start -->
<div class="fm-content-wrapper">
  <div class="fm-rs-steps">
    <!-- Page Title Start -->
    <div class="fm-page-title">
      <h2 class="fm-head-24 fm-title">Schedule a Memory Prompt</h2>
    </div>
    <!-- Page Title End -->

    <!-- Step Form Start -->
    <div class="fm-rs-step-form fm-schedule-prompt-form">

      <!-- STEP HEADER -->
      <div class="fm-step-wrapper">
        <div class="fm-white-column">
          <div class="fm-step-list">
            <div class="fm-step-item" [class.active]="currentStep() >= 1" [class.completed]="currentStep() > 1"
                 (click)="currentStep() > 1 && goToStep(1)" role="button" tabindex="0" aria-label="Step 1">
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step1-icon.svg" alt="Step 1" />
              </div>
              <div class="fm-step-number">Step 01</div>
              <div class="fm-step-title">Choose Category</div>
            </div>
            <div class="fm-step-item" [class.active]="currentStep() >= 2" [class.completed]="currentStep() > 2"
                 (click)="currentStep() > 2 && goToStep(2)" role="button" tabindex="0" aria-label="Step 2">
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step2-icon.svg" alt="Step 2" />
              </div>
              <div class="fm-step-number">Step 02</div>
              <div class="fm-step-title">Select Media Type</div>
            </div>
            <div class="fm-step-item" [class.active]="currentStep() >= 3" [class.completed]="currentStep() > 3"
                 (click)="currentStep() > 3 && goToStep(3)" role="button" tabindex="0" aria-label="Step 3">
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step3-icon.svg" alt="Step 3" />
              </div>
              <div class="fm-step-number">Step 03</div>
              <div class="fm-step-title">Select Questions</div>
            </div>
            <div class="fm-step-item" [class.active]="currentStep() >= 4"
                 role="button" tabindex="0" aria-label="Step 4">
              <div class="fm-step-icon">
                <img class="fm-svg" src="images/icons/fm-step4-icon_promt.svg" alt="Step 4" />
              </div>
              <div class="fm-step-number">Step 04</div>
              <div class="fm-step-title">Send to</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ============================================================ -->
      <!-- STEP 1: Choose Category                                       -->
      <!-- ============================================================ -->
      @if (currentStep() === 1) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-section-title">
                <h2 class="fm-head-24">What memory would you like to ask about?</h2>
                <p>Choose a category to get started with AI-powered prompts</p>
              </div>
              <div class="fm-category-grid">
                @for (cat of categories; track cat.id) {
                  <div class="fm-category-box">
                    <input type="radio" name="memory" [id]="'cat-' + cat.id"
                           [checked]="selectedCategory() === cat.id"
                           (change)="selectCategory(cat.id)" />
                    <label class="fm-category-label" [for]="'cat-' + cat.id">
                      <div class="fm-check-icon">
                        <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                      </div>
                      <div class="fm-category-icon">
                        <img [src]="cat.icon" class="fm-svg" [alt]="cat.name" />
                      </div>
                      <h4 class="fm-head-22">{{ cat.name }}</h4>
                      <p>{{ cat.prompts }} prompts available</p>
                    </label>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="fm-form-footer">
            <button type="button" class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel" (click)="cancelSchedule()">
              Cancel
            </button>
            <button type="button" class="fm-common-btn fm-btn-next" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 2: Select Media Type                                     -->
      <!-- ============================================================ -->
      @if (currentStep() === 2) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-compressed-cl">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">How should they answer?</h2>
                  <p>Choose how your loved one will share their {{ selectedCategoryName() }} memories</p>
                </div>
                <div class="fm-media-list">
                  @for (media of mediaTypes; track media.id) {
                    <div class="fm-media-card" [class.active]="selectedMedia() === media.id"
                         (click)="selectMedia(media.id)" role="button" tabindex="0">
                      <div class="fm-media-left">
                        <div class="fm-media-icon">
                          <img [src]="media.icon" class="fm-svg" [alt]="media.label" />
                        </div>
                        <div>
                          <h4 class="fm-head-22">{{ media.label }}</h4>
                          <p>{{ media.description }}</p>
                        </div>
                      </div>
                      <div class="fm-check-icon">
                        <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="fm-compressed-cl">
            <div class="fm-form-footer fm-space-between">
              <button type="button" class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel" (click)="prevStep()">
                <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                Back
              </button>
              <button type="button" class="fm-common-btn fm-btn-next" (click)="nextStep()">
                Continue
                <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
              </button>
            </div>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 3: Select Questions                                      -->
      <!-- ============================================================ -->
      @if (currentStep() === 3) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-compressed-cl fm-large-cl">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">Select Questions</h2>
                  <p>Choose which questions to send to your loved one</p>
                </div>

                <div class="fm-questions-header mb-2">
                  <span class="fm-selected-count">
                    {{ selectedQuestions().length }} of {{ questions().length }} selected
                  </span>
                  <div class="fm-select-actions">
                    <button type="button" class="fm-link-btn" (click)="selectAllQuestions()">Select All</button>
                    <span class="fm-divider">&nbsp;|&nbsp;</span>
                    <button type="button" class="fm-link-btn" (click)="clearAllQuestions()">Clear All</button>
                  </div>
                </div>

                <div class="fm-question-list">
                  @for (q of questions(); track q.id; let i = $index) {
                    <div class="fm-question-card" [class.active]="q.selected"
                         [class.fm-question-custom]="q.isCustom"
                         (click)="editingQuestionId() !== q.id && toggleQuestion(q.id)"
                         role="checkbox" [attr.aria-checked]="q.selected" tabindex="0"
                         (keydown.enter)="editingQuestionId() !== q.id && toggleQuestion(q.id)"
                         (keydown.space)="$event.preventDefault(); editingQuestionId() !== q.id && toggleQuestion(q.id)">
                      <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>

                      @if (editingQuestionId() === q.id) {
                        <div class="fm-inline-edit" (click)="$event.stopPropagation()">
                          <input type="text" class="form-control fm-inline-edit-input"
                                 [value]="editingQuestionText()"
                                 (input)="editingQuestionText.set($any($event.target).value)"
                                 (keydown.enter)="saveEditQuestion()"
                                 (keydown.escape)="cancelEditQuestion()" />
                          <button type="button" class="btn fm-icon-btn fm-icon-btn-save" (click)="saveEditQuestion()" aria-label="Save">
                            <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                          </button>
                          <button type="button" class="btn fm-icon-btn" (click)="cancelEditQuestion()" aria-label="Cancel">
                            <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                          </button>
                        </div>
                      } @else {
                        <p class="mb-0 fm-question-text">{{ q.text }}</p>
                      }

                      @if (q.isCustom && editingQuestionId() !== q.id) {
                        <div class="fm-question-actions fm-dropdown" (click)="$event.stopPropagation()">
                          <button type="button" class="fm-question-menu-btn" (click)="toggleQuestionMenu(q.id, $event)" aria-label="Open question actions">
                            <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                          </button>
                          @if (openMenuId() === q.id) {
                            <div class="dropdown-menu fm-dropdown-menu show">
                              <button type="button" class="dropdown-item fm-dropdown-item" (click)="startEditQuestion(q.id)">
                                <img src="images/icons/fm-edit.svg" class="fm-svg" alt="Edit" />
                                <span class="fm-question-action-label">Edit</span>
                              </button>
                              <button type="button" class="dropdown-item fm-dropdown-item fm-question-delete-btn" (click)="deleteQuestion(q.id)">
                                <img src="images/icons/fm-delete.svg" class="fm-svg" alt="Delete" />
                                <span class="fm-question-action-label">Delete</span>
                              </button>
                            </div>
                          }
                        </div>
                      }

                      <div class="fm-check-icon" aria-hidden="true">
                        <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                      </div>
                    </div>
                  }
                </div>

                <!-- Add Custom Question -->
                <div class="fm-add-question-btn">
                  <button type="button" class="fm-common-btn" (click)="toggleCustomQuestion()">
                    <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Add" />
                    Add Your Own Questions
                  </button>
                </div>
                @if (showCustomQuestion()) {
                  <div class="fm-custom-question">
                    <div class="form-group">
                      <input type="text" class="form-control" placeholder="Type your question..."
                             [value]="customQuestionText()"
                             (input)="customQuestionText.set($any($event.target).value)" />
                      <button type="button" class="btn fm-icon-btn" (click)="saveCustomQuestion()" aria-label="Save question">
                        <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                      </button>
                      <button type="button" class="btn fm-icon-btn" (click)="toggleCustomQuestion()" aria-label="Cancel">
                        <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="fm-compressed-cl fm-large-cl">
            <div class="fm-form-footer fm-space-between">
              <button type="button" class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel" (click)="prevStep()">
                <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                Back
              </button>
              <button type="button" class="fm-common-btn fm-btn-next"
                      [disabled]="selectedQuestions().length === 0" (click)="nextStep()">
                Continue
                <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
              </button>
            </div>
          </div>
        </div>
      }

      <!-- ============================================================ -->
      <!-- STEP 4: Send to                                               -->
      <!-- ============================================================ -->
      @if (currentStep() === 4) {
        <div class="fm-step-content active">
          <div class="fm-card-wrapper">
            <div class="fm-white-column">
              <div class="fm-schedule-prompt-card">
                <div class="fm-section-title">
                  <h2 class="fm-head-24">Who should answer?</h2>
                  <p>Select the loved one you'd like to send this memory prompt to</p>
                </div>
                <div class="fm-family-filter-inline">
                  <p class="fm-black-cl fm-icon-content mb-0 fm-family-filter-textline">
                    <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon"> Filter by Family :
                  </p>
                  <div class="fm-filter-tags fm-filter-selected fm-family-filter-tags-line">
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm fm-ft-active" data-family="all">All Family</button>
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" data-family="wilson">Wilson Family</button>
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" data-family="johnson">Johnsons Family</button>
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" data-family="williams">Williams Family</button>
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" data-family="miller">Miller Family</button>
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" data-family="johnson-circle">Johnsons Family Circle</button>
                  </div>
                </div>
                <div class="fm-card-group fm-filter-family fm-check-cards">
                  <div class="row g-3 g-xxl-4">
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagMia" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagMia">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-1.png" class="fm-card-sm-image img-fluid" alt="Mia Wilson" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Mia Wilson</p>
                          <ul>
                            <li>Sister</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Wilson Family</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagLiam" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagLiam">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-2.png" class="fm-card-sm-image img-fluid" alt="Liam Johnson" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Liam Johnson</p>
                          <ul>
                            <li>Father</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Johnsons Family</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagNoah" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagNoah">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-3.png" class="fm-card-sm-image img-fluid" alt="Noah Williams" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Noah Williams</p>
                          <ul>
                            <li>Brother</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Williams Family</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagEthan" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagEthan">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-4.png" class="fm-card-sm-image img-fluid" alt="Ethan Brown" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Ethan Brown</p>
                          <ul>
                            <li>Brother</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Johnsons Family Circle</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagIsabella" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagIsabella">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-5.png" class="fm-card-sm-image img-fluid" alt="Isabella Miller" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Isabella Miller</p>
                          <ul>
                            <li>Sister</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Miller Family</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-xxl-4">
                      <input type="checkbox" name="schedulePromptPeople" id="fmScheduleTagBenjamin" class="fm-check-card-input">
                      <label class="fm-card-sm" for="fmScheduleTagBenjamin">
                        <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" /></div>
                        <div class="fm-card-img">
                          <img src="images/people-6.png" class="fm-card-sm-image img-fluid" alt="Benjamin Harris" />
                        </div>
                        <div class="fm-card-content">
                          <p class="fm-card-name">Benjamin Harris</p>
                          <ul>
                            <li>Brother</li>
                            <li><span class="fm-dot"></span></li>
                            <li>Johnsons Family Circle</li>
                          </ul>
                        </div>
                      </label>
                    </div>
                  </div>
                  <p class="fm-filter-no-data fm-black-cl mt-3 mb-0 d-none">Data not found</p>
                </div>

                <!-- Form Fields -->
                <div class="row fm-prompt-form-row">
                  <!-- Prompt Frequency -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Prompt Frequency</h5>
                      </div>
                      <hr class="w-100 my-3" />
                      <div class="form-group">
                        <label class="fm-label">How often should we send this memory prompt?</label>
                        <select class="form-select fm-form-select" [ngModel]="promptFrequency()" (ngModelChange)="promptFrequency.set($event)">
                          <option value="daily">Daily (Every day)</option>
                          <option value="weekly">Weekly</option>
                          <option value="monthly">Monthly</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Questions Per Prompt -->
                  <div class="col-lg-6 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Questions Per Prompt</h5>
                      </div>
                      <hr class="w-100 my-3" />
                      <div class="form-group">
                        <label class="fm-label">How many questions should be included in each prompt?</label>
                        <select class="form-select fm-form-select" [ngModel]="questionsPerPrompt()" (ngModelChange)="questionsPerPrompt.set($event)">
                          <option value="1">1 Question</option>
                          <option value="2">2 Questions</option>
                          <option value="3">3 Questions</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Prompt Title -->
                  <div class="col-12 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Prompt Title</h5>
                      </div>
                      <div class="fm-common-card-body form-group mt-3">
                        <input type="text" class="form-control fm-form-control"
                               placeholder="Share a memory about your grandparents"
                               [ngModel]="promptTitle()" (ngModelChange)="promptTitle.set($event)" />
                      </div>
                    </div>
                  </div>
                  <!-- Stop Prompt -->
                  <div class="col-12 mt-4">
                    <div class="fm-common-card">
                      <div class="fm-common-card-header">
                        <h5 class="fm-head-18 fm-common-card-title">Stop Prompt</h5>
                      </div>
                      <hr class="w-100 mb-4" />
                      <div class="fm-common-card-body">
                        <div class="fm-stop-prompt-box">
                          <span class="fm-stop-prompt-text">{{ promptTitle() || 'Share a memory about your grandparents' }}</span>
                          <button type="button" class="fm-stop-btn">
                            <i class="bi bi-stop-circle" aria-hidden="true"></i>
                            Stop Prompt
                          </button>
                        </div>
                        <p class="fm-stop-note">
                          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                          Once stopped, this prompt will not be sent again and responses will no longer be accepted.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Prompt Summary -->
                <div class="fm-prompt-summary-box mt-4 mt-xl-5">
                  <div class="fm-prompt-summary-header">
                    <h4 class="fm-head-20 fm-prompt-summary-title">Prompt Summary</h4>
                  </div>
                  <div class="fm-prompt-summary-body">
                    <div class="row g-3 g-xl-4">
                      <div class="col-lg-4 col-md-6">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Category:</p>
                          <h6 class="fm-summary-value">{{ selectedCategoryName() }}</h6>
                        </div>
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Sending To:</p>
                          <h6 class="fm-summary-value">—</h6>
                        </div>
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Prompt Title:</p>
                          <h6 class="fm-summary-value">{{ promptTitle() || '—' }}</h6>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Questions:</p>
                          <h6 class="fm-summary-value">{{ selectedQuestions().length }} Selected From {{ selectedCategoryName() }}</h6>
                        </div>
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Questions Per Prompt:</p>
                          <h6 class="fm-summary-value">{{ questionsPerPrompt() }} Question{{ questionsPerPrompt() !== '1' ? 's' : '' }}</h6>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Answer Format:</p>
                          <h6 class="fm-summary-value">{{ selectedMediaLabel() }}</h6>
                        </div>
                        <div class="fm-summary-item">
                          <p class="fm-summary-label">Frequency:</p>
                          <h6 class="fm-summary-value">{{ promptFrequency() === 'daily' ? 'Daily (Every Day)' : promptFrequency() === 'weekly' ? 'Weekly' : 'Monthly' }}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-border-btn fm-white-btn fm-btn-cancel" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button type="button" class="fm-common-btn fm-btn-next" (click)="sendPrompt()">
              Send Prompt
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Send" />
            </button>
          </div>
        </div>
      }

    </div>
    <!-- Step Form End -->
  </div>
</div>
<!-- Content Wrapper End -->

<!-- Delete Question Confirmation Modal -->
@if (deleteConfirmId()) {
  <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="deleteModalTitle">
    <div class="fm-reload-modal">
      <div class="fm-reload-modal-icon">
        <span>&#9888;</span>
      </div>
      <h3 class="fm-reload-modal-title" id="deleteModalTitle">Delete Question</h3>
      <p class="fm-reload-modal-desc">Are you sure you want to delete this question?</p>
      <div class="fm-reload-modal-actions">
        <button type="button" class="fm-common-btn fm-primary-btn" (click)="confirmDelete()">Yes, Delete</button>
        <button type="button" class="fm-reload-leave-btn" (click)="cancelDelete()">Cancel</button>
      </div>
    </div>
  </div>
}